import NetworkLogic from "../../Shared/NetworkLogic";
import Player from "../../Models/Player";
import UIManager from "../../Shared/UIManager";
import AudioManager from "../../Shared/AudioManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class PlayerCheck extends cc.Component {
    @property(cc.SpriteFrame)
    sp1: cc.SpriteFrame = null;
    @property(cc.SpriteFrame)
    sp2: cc.SpriteFrame = null;
    @property(cc.Label)
    subordinateReturnNumber = null;
    @property(cc.Label)
    touzhuNumber = null;
    @property(cc.Node)
    content: cc.Node = null;
    @property(cc.Node)
    item: cc.Node = null;
    @property(cc.Node)
    empty: cc.Node = null;
    @property(cc.EditBox)
    editBox: cc.EditBox = null;
    @property(cc.Node)
    zhiShuDetail: cc.Node = null;

    private data = null;
    onLoad () {
        this.content.getChildByName("sp0").active = false;
        this.zhiShuDetail.active = false;
    }

    start () {
        this.check("")
    }
    check(userId){
        for (let i = 0;i< this.content.children.length;i++){
            this.content.children[i].active = false;
        }
        let data = {
            "registeredDate": "",
            "soubUserId": userId,
            "type": 1 //1按id查询，2 按时间查询
        }
        UIManager.showLoadingUI();
        NetworkLogic.agentSubordinateInfo(data,1,9999, async function (recdata) {
            console.log("====收到查询数据recdata:", recdata);
            UIManager.hideLoadingUI();
            this.data = recdata;
            this.showItem(recdata);
        }.bind(this),function () {
            console.log("=====查询数据错误")
        }.bind(this))
    }

    showItem(recdata){
        if (recdata.subordianteDetails.length > 0) {
            this.subordinateReturnNumber.string = recdata.subordinateReturnNumber;
            this.touzhuNumber.string = recdata.myTodayValidBetNumber;

            if (this.content.children.length > recdata.subordianteDetails.length){
                for (let i = recdata.subordianteDetails.length;i < this.content.children.length;i++ ){
                    this.content.children[i].active = false;
                }
            }
            for (let i = 0; i < recdata.subordianteDetails.length; i++) {
                let child = null;
                if (i < this.content.children.length){
                    child = this.content.children[i];
                }
                else{
                    child = cc.instantiate(this.item);
                    child.parent = this.content;
                }
                let childData = recdata.subordianteDetails[i];
                child.parent = this.content;
                child.getChildByName("bg").getComponent(cc.Sprite).spriteFrame = (i % 2 === 0 ? this.sp1 : this.sp2);
                child.getChildByName("labId").getComponent(cc.Label).string = childData.soubUserId;
                child.getChildByName("labToday").getComponent(cc.Label).string = childData.todayValidBetNumber;
                child.getChildByName("labTo").getComponent(cc.Label).string = childData.todayTotalValidBetNumber;
                child.getChildByName("labTotalPerson").getComponent(cc.Label).string = childData.teamTotalNumber;
                child.getChildByName("labDirectPerson").getComponent(cc.Label).string = childData.subordinateReturnNumber;
                child.getChildByName("btnDetail").getComponent(cc.Button).clickEvents[0].customEventData = childData.soubUserId;
                child.active = true;
                this.empty.active = false;
            }
        }
    }

    /**
     "myTodayValidBetNumber": 0,
     "subordianteDetails": [
     {
				"soubUserId": "",
				"subordinateReturnNumber": 0,
				"teamTotalNumber": 0,
				"todayTotalValidBetNumber": 0,
				"todayValidBetNumber": 0
			}
     ],
     "subordinateReturnNumber": 0
     * @param event
     * @param param
     */
    async onBtnClick(event,param){
        AudioManager.playSound("close");
        if (param === "cx"){
            console.log("====this.editBox.string:",this.editBox.string)
            this.check(this.editBox.string);

        }
        else if(param === "cz"){
            this.editBox.string = "";
            this.check("");
        }

    }


    onBtnDetail(event,param){
        AudioManager.playSound("button");
        let data = {
            "userId": param
        }
        UIManager.showLoadingUI();
        NetworkLogic.agentSubordinateRecordInfo(data,function (re) {
            UIManager.hideLoadingUI();
            this.zhiShuDetail.active = true;
            this.zhiShuDetail.emit("ZSDETAIL",re,param);
            console.log("===做二级界面re：",re);
        }.bind(this),function (err) {
            console.log("===代理错误err:",err)
        })
    }
}
